/**
 * The staff roles of Ommri Care Admin v2 (keys match the API catalogue).
 * Labels are the names the prototype shows on sign-in tiles and the topbar;
 * the API also returns them (me.activeRole.name).
 */
export const ROLES = [
  'front_desk',
  'doctor',
  'locum',
  'mental_health',
  'nurse',
  'lab',
  'dispenser',
  'finance',
  'clinic_manager',
  'super_admin',
] as const;

export type Role = (typeof ROLES)[number];

export const ROLE_LABELS: Record<Role, string> = {
  front_desk: 'Front desk',
  doctor: 'Doctor',
  locum: 'Locum doctor',
  mental_health: 'Mental-health practitioner',
  nurse: 'Nurse',
  lab: 'Lab / phlebotomist',
  dispenser: 'Dispenser',
  finance: 'Finance / panel claims',
  clinic_manager: 'Admin / clinic manager',
  super_admin: 'Super admin',
};

/**
 * Roles that must use two-factor when the API's policy is enforced (mirrors
 * ommri-care-api MFA_ENFORCED_ROLES). Locums may turn it on but are not made
 * to. Whether the policy is enforced in THIS deployment is decided by the API
 * at runtime and read from `me.mfa.required` (RL-2160); never from a build
 * value, and never by emptying this list for staging.
 */
export const MFA_REQUIRED_ROLES: readonly Role[] = [
  'finance',
  'clinic_manager',
  'super_admin',
];

export function isRole(value: unknown): value is Role {
  return (
    typeof value === 'string' && (ROLES as readonly string[]).includes(value)
  );
}
